import * as React from 'react';

function SvgReferImage(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={333.826}
      height={279.609}
      {...props}
    >
      <defs>
        <filter
          id="refer_image_svg__a"
          x={64.563}
          y={0}
          width={207.968}
          height={208.354}
          filterUnits="userSpaceOnUse"
        >
          <feOffset />
          <feGaussianBlur stdDeviation={27} result="blur" />
          <feFlood floodOpacity={0.349} />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="refer_image_svg__b"
          x={125.858}
          y={63.996}
          width={207.968}
          height={208.354}
          filterUnits="userSpaceOnUse"
        >
          <feOffset />
          <feGaussianBlur stdDeviation={27} result="blur-2" />
          <feFlood floodOpacity={0.341} />
          <feComposite operator="in" in2="blur-2" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="refer_image_svg__c"
          x={0}
          y={66.203}
          width={207.968}
          height={208.354}
          filterUnits="userSpaceOnUse"
        >
          <feOffset />
          <feGaussianBlur stdDeviation={27} result="blur-3" />
          <feFlood floodOpacity={0.341} />
          <feComposite operator="in" in2="blur-3" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="refer_image_svg__d"
          x={64.563}
          y={0}
          width={207.968}
          height={208.354}
          filterUnits="userSpaceOnUse"
        >
          <feOffset />
          <feGaussianBlur stdDeviation={27} result="blur-4" />
          <feFlood floodOpacity={0.349} />
          <feComposite operator="in" in2="blur-4" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="refer_image_svg__f"
          x={125.858}
          y={63.996}
          width={207.968}
          height={208.354}
          filterUnits="userSpaceOnUse"
        >
          <feOffset />
          <feGaussianBlur stdDeviation={27} result="blur-5" />
          <feFlood floodOpacity={0.341} />
          <feComposite operator="in" in2="blur-5" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="refer_image_svg__h"
          x={0}
          y={66.203}
          width={207.968}
          height={208.354}
          filterUnits="userSpaceOnUse"
        >
          <feOffset />
          <feGaussianBlur stdDeviation={27} result="blur-6" />
          <feFlood floodOpacity={0.341} />
          <feComposite operator="in" in2="blur-6" />
          <feComposite in="SourceGraphic" />
        </filter>
        <clipPath id="refer_image_svg__e" />
        <clipPath id="refer_image_svg__g" />
        <clipPath id="refer_image_svg__i" />
      </defs>
      <g transform="translate(-52.444 -49.45)">
        <path
          data-name="Ellipse 5"
          d="M129.102 221.754c-4.05 6.108-8.1 9.163-16.451 14s-23.032 22.4 13.92 33.087c35.687 10.944 33.156 9.417 29.106 14s-15.945 3.309-12.655 8.908 9.618 19.852 82.257 20.361c18.729.764 27.588-9.163 17.717-16.543 7.593-4.836 88.331-73.046 11.389-96.715s-66.565-31.305-60.744-35.632 16.7-23.924-18.982-19.089-65.046 23.415-27.841 38.177c20.248 8.4 13.161 15.016 1.266 14s-23.285 4.581-20.248 14 3.802 11.187 1.266 11.446z"
          fill="#008afd"
          opacity={0.12}
        />
        <g
          data-name="Ellipse 7"
          transform="translate(163.904 160.742)"
          fill="rgba(255,210,0,0)"
          stroke="#fff"
          strokeLinecap="round"
          strokeWidth={2.28}
          strokeDasharray="0 4.56"
        >
          <ellipse cx={54.578} cy={54.964} rx={54.578} ry={54.964} stroke="none" />
          <ellipse cx={54.578} cy={54.964} rx={53.438} ry={53.824} fill="none" />
        </g>
        <g
          data-name="Rounded Rectangle 1"
          transform="translate(197.416 202.188)"
          fill="#008afd"
          stroke="#0d376a"
          strokeLinejoin="round"
        >
          <rect width={42.134} height={73.294} rx={4} stroke="none" />
          <rect x={-0.5} y={-0.5} width={43.134} height={74.294} rx={4.5} fill="none" />
        </g>
        <g data-name="Rectangle 1" fill="#fff" stroke="#0d386b" strokeLinejoin="round">
          <path stroke="none" d="M202.179 213.765h32.559v50.141h-32.559z" />
          <path fill="none" d="M201.679 213.265h33.559v51.141h-33.559z" />
        </g>
        <rect
          data-name="Rounded Rectangle 2"
          width={12.457}
          height={1.893}
          rx={0.79}
          transform="translate(212.742 207.023)"
          fill="#0d386b"
        />
        <path
          data-name="Ellipse 1"
          d="M198.381 260.063a17.987 17.987 0 012.872 3.858c2.3 1.736 4.787 4.243 2.872 10.609 11.1 0 14.386.223 14.386.223.191-1.736 2.654-3.887 3.8-5.045s-.191-4.436-1.915-6.751-4.393-13.294-.564-15.8c3.439-1.928 15.9-6.354 26.09 18.8 2.43 5.886 1.264 21.836-11.963 28.824-4.978 3.783-27.438 6.543-32.669-14.244-6.194-2.075-16.431-16.542-2.909-20.474z"
          fill="#1d5190"
        />
        <path
          data-name="Ellipse 2"
          d="M198.056 276.096c-.817 0-1.552-.928-2.547-2.53a17.591 17.591 0 01-2.106-4.924c-.411-1.7-.342-3.039.192-3.756.671-.902 2.068-2.244 3.168-2.244a1.141 1.141 0 01.846.359c.566.582.826 1.865.772 3.813a2.59 2.59 0 00.357 1.947.833.833 0 00.644.278 1.894 1.894 0 00.917-.3.632.632 0 01.315-.092c.275 0 .527.227.709.639a5.489 5.489 0 01-1.024 5.239c-1.029 1.132-1.661 1.571-2.243 1.571z"
          fill="#fff"
        />
        <path
          data-name="Ellipse 3"
          d="M203.501 276.533c8.01.059 11.478 0 11.478 0 .383 4.629 1.782 13.235 4.463 14.392-3.135-7.374-1.927-14.956 6.574-21.069-3.255-3.858-9.225-17.567-4.66-21.366 2.032-2.152 15.508-4.629 22.975 21.217 1.723 7.908-1.34 25.461-22.975 26.039-5.743-.77-18.486-6.082-17.855-19.213z"
          fill="#fff"
        />
        <g
          data-name="Ellipse 4"
          transform="translate(190.711 235.953)"
          fill="#fff"
          stroke="#1d518f"
          strokeLinejoin="round"
          strokeWidth={2}
        >
          <ellipse cx={4.317} cy={5.788} rx={4.317} ry={5.788} stroke="none" />
          <ellipse cx={4.317} cy={5.788} rx={5.317} ry={6.788} fill="none" />
        </g>
        <g
          data-name="Ellipse 4 copy"
          transform="translate(190.711 249.423)"
          fill="#fff"
          stroke="#1d518f"
          strokeLinejoin="round"
          strokeWidth={2}
        >
          <ellipse cx={3.847} cy={5.33} rx={3.847} ry={5.33} stroke="none" />
          <ellipse cx={3.847} cy={5.33} rx={4.847} ry={6.33} fill="none" />
        </g>
        <ellipse
          data-name="Ellipse 6"
          cx={2.858}
          cy={2.894}
          rx={2.858}
          ry={2.894}
          transform="translate(95 180.024)"
          fill="#008afd"
        />
        <path
          data-name="Forma 1"
          d="M108.781 154.946a.48.48 0 01-.48-.48v-2.02a.48.48 0 01.48-.48h.186a.48.48 0 01.48.48v2.019a.48.48 0 01-.48.48zm5.03-2.4l-1.275-1.294a.584.584 0 010-.82.574.574 0 01.814 0l1.276 1.286a.578.578 0 11-.814.82zm-10.69 0a.582.582 0 010-.82l1.276-1.286a.573.573 0 01.814 0 .582.582 0 010 .82l-1.275 1.278a.586.586 0 01-.407.169.56.56 0 01-.408-.169zm1.823-5.8a3.929 3.929 0 113.928 3.957 3.955 3.955 0 01-3.928-3.957zm1.137 0a2.792 2.792 0 102.792-2.815 2.8 2.8 0 00-2.792 2.815zm8.544.58a.58.58 0 010-1.159h1.811a.571.571 0 01.575.58.58.58 0 01-.575.58zm-13.314 0a.581.581 0 01-.575-.58.572.572 0 01.576-.58h1.81a.58.58 0 010 1.159zm11.225-4.272a.584.584 0 010-.82l1.275-1.288a.573.573 0 01.814 0 .582.582 0 010 .82l-1.276 1.288a.573.573 0 01-.814 0zm-8.137 0l-1.278-1.286a.582.582 0 010-.82.573.573 0 01.814 0l1.276 1.286a.582.582 0 010 .82.571.571 0 01-.814 0zm3.899-2.108v-1.821a.575.575 0 111.15 0v1.821a.575.575 0 11-1.15 0z"
          fill="#fff"
          opacity={0.702}
        />
        <path
          data-name="Forma 1 copy"
          d="M104.469 286.094a.28.28 0 01-.281-.28v-1.189a.281.281 0 01.281-.28h.115a.28.28 0 01.28.28v1.189a.28.28 0 01-.28.28zm2.958-1.4l-.752-.757a.343.343 0 010-.482.337.337 0 01.479 0l.752.756a.34.34 0 11-.479.482zm-6.289 0a.344.344 0 010-.482l.752-.756a.337.337 0 01.479 0 .343.343 0 010 .482l-.751.757a.342.342 0 01-.239.1.331.331 0 01-.244-.105zm1.074-3.414a2.31 2.31 0 112.31 2.329 2.326 2.326 0 01-2.31-2.329zm.668 0a1.643 1.643 0 101.642-1.654 1.647 1.647 0 00-1.642 1.654zm5.026.341a.341.341 0 010-.681h1.064a.336.336 0 01.338.34.341.341 0 01-.338.341zm-7.831 0a.342.342 0 01-.34-.341.336.336 0 01.339-.34h1.061a.341.341 0 010 .681zm6.6-2.511a.343.343 0 010-.482l.752-.757a.337.337 0 01.479 0 .344.344 0 010 .482l-.752.756a.337.337 0 01-.479 0zm-4.786 0l-.754-.751a.344.344 0 010-.482.337.337 0 01.479 0l.751.757a.343.343 0 010 .482.337.337 0 01-.479 0zm2.295-1.238v-1.073a.339.339 0 11.677 0v1.073a.339.339 0 11-.677 0z"
          fill="#fff"
          opacity={0.639}
        />
        <ellipse
          data-name="Ellipse 6 copy 2"
          cx={2.882}
          cy={2.894}
          rx={2.882}
          ry={2.894}
          transform="translate(98.256 191.986)"
          fill="#61d2fe"
        />
        <ellipse
          data-name="Ellipse 6 copy 8"
          cx={2.858}
          cy={2.894}
          rx={2.858}
          ry={2.894}
          transform="translate(217.59 323.271)"
          fill="#fff"
          opacity={0.588}
        />
        <ellipse
          data-name="Ellipse 6 copy 3"
          cx={2.882}
          cy={2.894}
          rx={2.882}
          ry={2.894}
          transform="translate(247.195 205.094)"
          fill="#00cd00"
        />
        <ellipse
          data-name="Ellipse 6 copy 4"
          cx={2.858}
          cy={2.894}
          rx={2.858}
          ry={2.894}
          transform="translate(175.42 161.683)"
          fill="#ff9a14"
        />
        <ellipse
          data-name="Ellipse 6 copy 10"
          cx={1.917}
          cy={1.929}
          rx={1.917}
          ry={1.929}
          transform="translate(96.327 112)"
          fill="#fff"
        />
        <ellipse
          data-name="Ellipse 6 copy 7"
          cx={2.858}
          cy={2.894}
          rx={2.858}
          ry={2.894}
          transform="translate(297.999 139.627)"
          fill="#c2c5ff"
        />
        <ellipse
          data-name="Ellipse 6 copy 11"
          cx={2.858}
          cy={2.894}
          rx={2.858}
          ry={2.894}
          transform="translate(303.931 251.46)"
          fill="#f7f7f8"
          opacity={0.541}
        />
        <ellipse
          data-name="Ellipse 6 copy 5"
          cx={1.435}
          cy={1.459}
          rx={1.435}
          ry={1.459}
          transform="translate(133.275 188.682)"
          fill="#ff4893"
        />
        <g data-name="Ellipse 6 copy">
          <g transform="translate(52.447 49.45)" filter="url(#refer_image_svg__d)">
            <ellipse
              data-name="Ellipse 6 copy"
              cx={22.984}
              cy={23.177}
              rx={22.984}
              ry={23.177}
              transform="translate(145.56 81)"
              fill="#ff4893"
            />
          </g>
          <g clipPath="url(#refer_image_svg__e)" transform="translate(198.007 130.45)">
            <image
              data-name="Group 1"
              width={30.147}
              height={38.588}
              transform="translate(7.935 6.874)"
              xlinkHref="data:image/png;base64,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"
            />
          </g>
        </g>
        <g data-name="Ellipse 6 copy 6">
          <g transform="translate(52.442 49.446)" filter="url(#refer_image_svg__f)">
            <ellipse
              data-name="Ellipse 6 copy 6"
              cx={22.984}
              cy={23.177}
              rx={22.984}
              ry={23.177}
              transform="translate(206.86 145)"
              fill="#00cd00"
            />
          </g>
          <g
            data-name="Clip"
            clipPath="url(#refer_image_svg__g)"
            transform="translate(259.302 194.446)"
          >
            <image
              data-name="&lt;Trazado&gt;\xA0+\xA0&lt;Trazado&gt;\xA0+\xA0&lt;Trazado&gt;\xA0+\xA0&lt;Trazado&gt;\xA0+\xA0&lt;Trazado&gt;\xA0+\xA0&lt;Trazado&gt;"
              width={27.735}
              height={36.177}
              transform="translate(9.346 9.201)"
              xlinkHref="data:image/png;base64,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"
            />
          </g>
        </g>
        <g data-name="Ellipse 6 copy 9">
          <g transform="translate(52.444 49.453)" filter="url(#refer_image_svg__h)">
            <ellipse
              data-name="Ellipse 6 copy 9"
              cx={22.984}
              cy={23.177}
              rx={22.984}
              ry={23.177}
              transform="translate(81 147.2)"
              fill="#ff9a14"
            />
          </g>
          <g
            data-name="Clip"
            clipPath="url(#refer_image_svg__i)"
            transform="translate(133.444 196.653)"
          >
            <image
              data-name="Group 2"
              width={33.765}
              height={36.177}
              transform="translate(7.38 9.406)"
              xlinkHref="data:image/png;base64,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"
            />
          </g>
        </g>
        <image
          data-name="Capa 1"
          width={18.088}
          height={18.088}
          transform="translate(209.559 221.735)"
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAABHNCSVQICAgIfAhkiAAAAvFJREFUKJF1kc9PFHcYxj+zM/OdAQZQEHZhI8VdCgKFXd0CZSO2khKN0WwqtkmbtqemaWJimlTT9Niklx6b9A/oj0Nr4qFaYy2lBqsGFRowFqpbwNQF5OcursvO7uzsTA9KGw99kjd5Ds/nfQ4PPCufUOSgqqrHm7oHJk58ec794IuzbmN4/00kz6BQ5SDg3QpLW6a83Og//trAqdra7ZVCL+n0N3cYeqkBgJlJszAz9di28nceJJZS53+8/Fkmk73xL/xSd+ela9fPH0yu/M30n7MUCyaFnAlIaCWleBSNULgNzaimN3Lo+8mp2TcVoLEqED7ZEunsk6Vl5uYWuDU2jWHo2LbD5mYWu1hkc7OAppXQ02XxfE/08Gxa+VyprW/4NLi3792MmQD5LrK7jmVB1gSjTLC7LUipXkYukyTgz4F6j0BboKI1pZ+WO7ujn7z/4Uf+1PIqSzOT+Ha4CM1B9djU1z1HNBomsEsQbJVxrUW++maUZK6Bg0fekBRcTH9D0B1872NpYvQqZ4Z+IPZyGUePRXCdSoRYAlKM/Pw7F38zqWl5m/6BXiTHQXEch0K+gG5UsnffIVK7IwxdP8vVsUscPtBAPm/z05V58mX76IoNUrWjBtkDjx+toTwZzMWxC7gueH0+vI17mLgyz+XpALZd5GFWpz0Uos7vw8ya4HgAnsJPJ1dVhfjULeLjv3Li1Gmqa6uQgMXEPN99/S2aELR0vEixYAPg2UJVVbCYmGV85AKvv/MWFduqSa7mWV/N463fSexYjDujQ8zfjyM08V+zqqqk1h9y7eIZjsRi7NzVRHLNRJaf/N5I5Whqb+eVZJKR4XMYFeXoeikeVageF4v7d29z4NX9RKIRMmkHvURHFQJVCDRdI/3Ipa+/j56ePdwYvoBl5ZC313hPyrJSFwm/QGtHiJXlNMVijoL17NmFHBsbJs1tzSRm7vHH5DjKyuLCg/jtsaberpA0F/8Lu2jzf3JdSK0JGgMBRoZ/4R/AeiwOo3piOQAAAABJRU5ErkJggg=="
        />
        <path
          data-name="Rounded Rectangle 4"
          d="M207.183 122.485a.476.476 0 01.674.065l2.442 2.979a.486.486 0 01-.064.68.476.476 0 01-.674-.064l-2.437-2.979a.486.486 0 01.059-.681z"
          fill="#fff"
        />
        <path
          data-name="Rounded Rectangle 4 copy"
          d="M214.085 118.746a.48.48 0 01.546.405l.575 3.822a.479.479 0 11-.947.145l-.575-3.822a.483.483 0 01.401-.55z"
          fill="#fff"
        />
        <path
          data-name="Rounded Rectangle 4 copy 2"
          d="M223.084 118.102a.483.483 0 01.4.549l-.568 3.823a.48.48 0 11-.948-.143l.568-3.823a.48.48 0 01.548-.406z"
          fill="#fff"
        />
        <path
          data-name="Rounded Rectangle 4 copy 3"
          d="M231.733 121.071a.486.486 0 01.124.672l-2.171 3.186a.477.477 0 01-.666.125.486.486 0 01-.123-.672l2.171-3.186a.476.476 0 01.665-.125z"
          fill="#fff"
        />
      </g>
    </svg>
  );
}

export default SvgReferImage;
